import { POST_HTTP, MASTER_NAMESPACE } from './typeConstants';

export const getTenantChanges = (requestData, storeKey) => ({
    //I know this looks weird, this is an effective "GET", using 
    // a POST, because we need to send a payload
    type: POST_HTTP,
    namespace: MASTER_NAMESPACE,
    requestData,
    storeKey,
});